import { Outlet } from "react-router-dom"
import bg2 from '../assets/images/bg2.jpg';

// The form on white beside the One International Towers façade; on narrow screens the photo
// becomes a strip above the form so nothing is squeezed.
const AuthLayout = () => {

    return (
        <div className="flex min-h-screen w-full flex-col bg-white min-[1080px]:flex-row">
            <aside className="relative h-28 shrink-0 overflow-hidden bg-primaryText min-[1080px]:order-2 min-[1080px]:h-auto min-[1080px]:flex-1">
                <img src={bg2} alt="" className="absolute inset-0 h-full w-full object-cover object-[60%_35%] min-[1080px]:object-[60%_50%]"/>
                <p className="absolute bottom-8 left-8 hidden rounded-md bg-scrim px-3 py-2 text-sm font-medium text-white min-[1080px]:block">
                    One International Towers, Barangaroo
                </p>
            </aside>
            <main className="flex flex-1 items-start justify-center px-4 pb-8 pt-6 min-[1080px]:items-center min-[1080px]:px-6 min-[1080px]:py-12">
                <Outlet />
            </main>
        </div>
    )
}

export default AuthLayout;
